/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { CloserSyncTransaction } from '@models/mortgages/closer-sync-instruction';
import { MortgageTransactionStatus } from '@models/mortgages/mortgage-base';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class CloserSyncTransactionRepoService extends Repo<
	CloserSyncTransaction,
	unknown
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
	GetCollectionPath(): string {
		return CollectionPaths.business_mortgagesV2(this.businessId);
	}

	getValidTransactions = (): Observable<any[]> => this.All(null, (ref) => ref);

	getUnassignedTransactions = (): Observable<any> =>
		this.All(null, (ref) =>
			ref
				.where('valid', '==', true)
				.where('status', '==', MortgageTransactionStatus.ACCEPTED),
		).pipe(
			map((x: CloserSyncTransaction[]) =>
				x.filter(
					(y: CloserSyncTransaction) =>
						!(y?.matterId?.length > 0) || y?.matterId === null,
				),
			),
		);

	getInstructionByVersionId = (
		transactionId: string,
		versionId: string,
	): Observable<any> =>
		this.firestore
			.collection(
				`${this.GetCollectionPath()}/${transactionId}/instructionVersions/`,
			)
			.doc(versionId)
			.get();
}
